import { render, staticRenderFns } from "./HopesDreamsModal.vue?vue&type=template&id=1ff6b232&scoped=true&"
import script from "./HopesDreamsModal.vue?vue&type=script&lang=js&"
export * from "./HopesDreamsModal.vue?vue&type=script&lang=js&"
import style0 from "./HopesDreamsModal.vue?vue&type=style&index=0&id=1ff6b232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff6b232",
  null
  
)

export default component.exports